module.exports = __webpack_public_path__ + "img/orders.e4d177cc.svg";